// multi use file (score, expand text, recommendations/takeaway)
import $ from 'jquery';

class ExpandedText {
    constructor () {
        this.$expandAccordion = $('.js-expand-accordion');

        this.$expandAccordion.on('click', $.proxy(ExpandedText.toggleText, this));
    }

    static toggleText (e) {
        const $elem       = $(e.currentTarget);
        const $hiddenText = $elem.closest('.js-expand-text').find('.js-hidden-text');

        $elem.toggleClass('is-open');

        // toggle text
        if ($elem.hasClass('is-open')) {
            $elem.find('.c-expand-text__expand-button-text--more').hide();
            $elem.find('.c-expand-text__expand-button-text--less').show();
            $hiddenText.slideDown();
        }
        else {
            $elem.find('.c-expand-text__expand-button-text--more').show();
            $elem.find('.c-expand-text__expand-button-text--less').hide();
            $hiddenText.slideUp();
        }
    }
}

export default ExpandedText;
